import React from "react";

const NetWorkSelectForm = ({ data }) => {
  return (
    <>
      <option value={data?.name} key={data?._id}>
        {data?.name}
      </option>
    </>
  );
};

export default NetWorkSelectForm;
